import Tracker from "./Tracker";
import { initAnalytics } from "./analytics";
import { cacheHelper } from "./cache";

class ActionTracker extends Tracker {
  constructor(options) {
    super(options);

    if (!this.debug) {
      this.productId = options.productId;
      this.url = options.url;
      this.projectRef = options.projectRef;
      this.analytics = initAnalytics(this.projectRef, this.url, this.productId);
      cacheHelper.listener(options.url);
    }
  }

  logEvent(payload, params) {
    // log event only if in prod mode
    if (this.debug) {
      return super.logEvent(payload, params);
    }

    return super.logActionEvent(payload, this.analytics, params);
  }

}

export default ActionTracker;